<template>
  <div id="page-container"
       v-if="config"
       class="sidebar-dark side-scroll page-header-fixed">
    <scorekeeper-topbar></scorekeeper-topbar>

    <div v-if="!config.scorekeeper_stopwatch_disabled" class="small-stopwatch-container">
      <small-stopwatch />
    </div>

    <main id="main-container">
      <transition name="fade">
        <loader v-if="this.$store.state.loading"></loader>
      </transition>
      <router-view :key="currentClient.uuid"></router-view>
    </main>
    <!-- END Main Container -->
    <bottombar></bottombar>
  </div>
</template>

<script>
import Bottombar from '@/components/layout/Bottombar'
import Loader from '@/components/layout/Loader'
import App from '../oneui/app'
import apiService from '@/services/api.service'
import ScorekeeperTopbar from '@/components/layout/ScorekeeperTopbar.vue'
import SmallStopwatch from '@/components/SmallStopwatch.vue'
import { useStopwatch } from '@/use/useStopwatch'

export default {
  name: 'ScorekeeperLiveLayout',
  components: {
    ScorekeeperTopbar,
    Bottombar,
    Loader,
    SmallStopwatch
  },
  async beforeRouteEnter (to, from, next) {
    apiService.setGameCode(to.params.code)
    next()
  },
  setup () {
    const { initStopwatch, activeStopwatch, isActiveCurrentStopwatch, stopwatchId, destroyStopwatch } = useStopwatch('smallStopwatch')
    return {
      initStopwatch,
      activeStopwatch,
      isActiveCurrentStopwatch,
      stopwatchId,
      destroyStopwatch
    }
  },
  created () {
    if (!this.config?.scorekeeper_stopwatch_disabled) {
      this.initStopwatch('smallStopwatch')
    }
    // eslint-disable-next-line
    jQuery(() => {
      // Create a new instance of App
      window.One = new App()
    })
  },
  destroyed () {
    if (!this.config?.scorekeeper_stopwatch_disabled) {
      this.destroyStopwatch()
    }
  },
  computed: {
    currentClient () {
      return this.$store.state.currentClient
    },
    config () {
      return this.$store.state.config
    }
  }
}
</script>

<style lang="scss">
  .fade-leave-active {
    transition-property: opacity;
    transition-duration: .1s;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0
  }

  #main-container {
    position: relative;
  }

  .small-stopwatch-container {
    position: fixed;
    bottom: 15px;
    right: 15px;
    z-index: 9999999;
    pointer-events: none;

    & > * {
      pointer-events: auto;
    }
  }

  /* Adjust page content to not be covered by fixed stopwatch if necessary */
  /* This depends on where exactly we want it to appear */
</style>
